export const FEATURE_FLAG = {
  TOURNAMENT_MARKET_GROUPS: 'enable-tournament-market-groups',
  LANGUAGE_OPTIONS: 'language-configuration',
  FEED_SOURCE_OPTIONS: 'feed-source-options',
  REGISTRATION_FLOW_CONFIG: 'registration-flow-config',
  PAYMENT_GATEWAY_OPTIONS: 'payment-gateway-options',
  AUTH_MODEL_OPTIONS: 'auth-model-options',
  MOBILE_DATA_GRID: 'mobile-data-grid-enabled',
  PROMOTIONS_ENABLED: 'promotions-enabled',
  CASINO_CASHBACK_BONUS: 'casino-cashback-bonus',
  OPENREPLAY_TRACKING: 'openreplay-tracking-bo',
} as const;
